import styled from 'styled-components';

interface FlagWrapperProps {
  isActive: boolean;
}
export const FlagWrapper = styled.div<FlagWrapperProps>`
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${(props) => (props.isActive ? '#e8e8e8' : '#fff')};
    border: 1px solid ${(props) => (props.isActive ? '#e8e8e8' : '#fff')};
`;
